import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Button } from 'react-bootstrap'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table'

import Collapsible from '../collapsible'
import Validators from '../../utils/validators'

@observer(['shippingtypes'])
export default class ShippingTypes extends Component {

  constructor(props) {
    super(props)

    this.props.shippingtypes.loadAllShippingTypes()
  }

  newShippingType(row) {
    this.props.shippingtypes.newShippingType(row.name)
  }

  updateShippingType(row, cellText, cellValue) {
    this.props.shippingtypes.updateShippingType(row.id, cellValue)
  }

  deleteShippingType(id) {
    if (confirm('Are you sure you want to delete this Shipping Type?')) {
      this.props.shippingtypes.deleteShippingType(id)
    }
  }

  formatActions(cell, row) {
    return <Button bsSize="small" bsStyle="danger" id={ cell } onClick={ () => { this.deleteShippingType(cell) } }><i className="fa fa-trash" aria-hidden="true"></i></Button>
  }

  render() {
    const options = {
      onAddRow: this.newShippingType.bind(this)
    }

    const shippingTypesTable = (
      <BootstrapTable
          data={ this.props.shippingtypes.data }
          striped={ true }
          hover={ true }
          pagination={ true }
          search={ true }
          exportCSV={ true }
          options={ options }
          insertRow={ true }
          bordered={ false }
          cellEdit={ { mode: 'click', blurToSave: false, afterSaveCell: this.updateShippingType.bind(this) } } >
        <TableHeaderColumn width="50" dataField="id" isKey={ true } dataSort={ true } dataAlign="center" hiddenOnInsert={ true } autoValue={ true }>ID</TableHeaderColumn>
        <TableHeaderColumn width="150" dataField="name" dataSort={ true } editable={{ validator: Validators.validString }}>Name</TableHeaderColumn>
        <TableHeaderColumn width="50" dataField="id" hiddenOnInsert={ true } autoValue={ true } dataFormat={ this.formatActions.bind(this) }>Actions</TableHeaderColumn>
      </BootstrapTable>
    )

    return (
      <div>
        <Collapsible title="Shipping Types" content={ shippingTypesTable } />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/admin/shippingtypes.js